import * as types from "../actions/actionTypes";

const initialState = {
    dataLoadSchedule: {
        pipelineName: [],
        list: [],
        descriptions: [],
        status: [],
    },
    cacheRefresh: {
        message: "",
    },
    tatClear: {
        message: "",
    }
};

export default function adminReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_PIPELINES: {
            const { data } = action.payload;
            return {
                ...state,
                dataLoadSchedule: {
                    ...state.dataLoadSchedule,
                    list: data,
                },
            };
        }

        case types.GET_PIPELINES_FILTERS: {
            const { data } = action.payload;
            return {
                ...state,

                dataLoadSchedule: {
                    ...state.dataLoadSchedule,
                    pipelineName: data.names,
                    status: data.statuses,
                    descriptions: data.descriptions,
                },
            };
        }

        case types.REFRESH_CACHE: {
            const { data } = action.payload;
            return {
                ...state,
                cacheRefresh: {
                    message: data,
                },
            };
        }

         case types.CLEAR_TAT_CACHE: {
            const { data } = action.payload;
            return {
                ...state,
                tatClear: {
                    message: data,
                },
            };
        }
        
        default:
            return state;
    }
}
